import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Context from "../context";

function Home() {
	const { t } = useTranslation();
	const user = useContext(Context);
	const roles = user?.roles;

	if (roles)
		switch (roles[0]) {
			case "ADMIN":
				return <Navigate to="/perfil" replace />;
			case "TECHNICIAN":
				return <Navigate to="/perfil-mobile" replace />;
			default:
				return <Navigate to="/open" replace />;
		}
	return <p>{t("COMMON.UNEXPECTED_ERROR")}</p>;
}
export default Home;
